"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _listFilterFunction = _interopRequireDefault(require("../utils/listFilterFunction"));

var _option = _interopRequireDefault(require("../../DropDown/views/option.c"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var ListRender = function ListRender(props) {
  var list = props.list;

  if (props.query) {
    list = list.filter((0, _listFilterFunction["default"])(props.query, props.searchFilter));
  }

  if (list && list.length) {
    return props.render({
      list: list
    });
  } else {
    var content = props.emptyListPlaceholder;
    return _react["default"].createElement(_option["default"], {
      theme: props.theme,
      title: content
    }, content);
  }
};

ListRender.propTypes = {
  list: _propTypes["default"].array,
  emptyListPlaceholder: _propTypes["default"].string,
  query: _propTypes["default"].string,
  render: _propTypes["default"].func,
  searchFilter: _propTypes["default"].func,
  theme: _propTypes["default"].object
};
var _default = ListRender;
exports["default"] = _default;